export default __webpack_public_path__ + "static/media/netherworlddeception.3661e0f5.png";